export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-sidebar-minimizer/index.ts